module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAFVBMVEUAcsY9vVgAcsYetTqbyOmo4rP///8qsuxKAAAAAnRSTlPU/snCEjgAAAA3SURBVEjH7csxAQAgEMSws4AFLGABC1jAv4TX0PmaPVlYDmaxWErLw/Ixi8VSWi6WjVksltLCDWuaIGB4ezEiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sl.png
// module id = bxsC
// module chunks = 0